// extracted by mini-css-extract-plugin
export var actionButton = "_7c-1";
export var actionButtons = "_7c-2";
export var actions = "_7c-0";
export var aiUnread = "_7c-10";
export var alignCenter = "_7c-h";
export var backWrapper = "_7c-3";
export var cellContainer = "_7c-4";
export var checkboxContainer = "_7c-5";
export var contentContainer = "_7c-6";
export var contentHeader = "_7c-8";
export var conversationsTableWrapper = "_7c-s";
export var draftReplyBadgeContainer = "_7c-m";
export var dropdownItem = "_7c-b";
export var dropdownItemsContainer = "_7c-a";
export var dropdownTitle = "_7c-c";
export var errorIcon = "_7c-7";
export var filter = "_7c-d";
export var gray = "_7c-i";
export var headerActionButtons = "_7c-e";
export var headerCheckboxContainer = "_7c-f";
export var icon = "_7c-j";
export var menuContainer = "_7c-k";
export var noMoreTicketsIcon = "_7c-12";
export var noMoreTicketsSubText = "_7c-13";
export var oneLine = "_7c-l";
export var optionsButton = "_7c-n";
export var plus = "_7c-o";
export var portalButtonsWrapper = "_7c-g";
export var red = "_7c-p";
export var scrolledTop = "_7c-9";
export var search = "_7c-q";
export var selectedConversationsCount = "_7c-r";
export var spinner = "_7c-t";
export var strong = "_7c-u";
export var summaryCell = "_7c-v";
export var tableContainer = "_7c-11";
export var tagContainer = "_7c-w";
export var threeDots = "_7c-x";
export var twoLines = "_7c-y";
export var unread = "_7c-z";